import React from 'react';
import { Row, Col } from 'antd';
import { Header } from './Header';
import { Container } from './Container';

export function Content() {
	return (
		<Row>
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>
				<Container />
			</Col>
		</Row>
	);
}
